import { http } from '@/services/http';

export interface FormSection {
  id: number;
  section_num: number;
  name: string;
  display_name: string;
  controls?: unknown[];
  [key: string]: unknown;
}

function sectionsScope(projectId: number | string, formId: number | string): string {
  return `projects/${projectId}/forms/${formId}/sections`;
}

export const sectionsApi = {
  index(projectId: number | string, formId: number | string): Promise<FormSection[]> {
    return http<FormSection[]>({ url: sectionsScope(projectId, formId), method: 'get' });
  },

  get(
    projectId: number | string,
    formId: number | string,
    sectionId: number | string,
  ): Promise<FormSection> {
    return http<FormSection>({
      url: `${sectionsScope(projectId, formId)}/${sectionId}`,
      method: 'get',
    });
  },

  create(
    projectId: number | string,
    formId: number | string,
    section: Partial<FormSection>,
  ): Promise<FormSection> {
    return http<FormSection>({
      url: sectionsScope(projectId, formId),
      method: 'post',
      data: section,
    });
  },

  update(
    projectId: number | string,
    formId: number | string,
    section: Partial<FormSection> & { id: number },
  ): Promise<FormSection> {
    return http<FormSection>({
      url: `${sectionsScope(projectId, formId)}/${section.id}`,
      method: 'patch',
      data: section,
    });
  },

  remove(
    projectId: number | string,
    formId: number | string,
    sectionId: number | string,
  ): Promise<void> {
    return http<void>({
      url: `${sectionsScope(projectId, formId)}/${sectionId}`,
      method: 'delete',
    });
  },

  newBlank(): FormSection {
    return { id: 0, section_num: 0, name: 'Section Name', display_name: 'Display Name' };
  },
};
